// extracted by mini-css-extract-plugin
module.exports = {"root":"ServicesIcons_root__1la3y","services":"ServicesIcons_services__2PSbF","servicesItem":"ServicesIcons_servicesItem__2ReHu","servicesIcon":"ServicesIcons_servicesIcon__1dAo6"};